import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button
} from "@mui/material";

// ✅ FIXED IMPORT
import { useGetIndiaLanguagesQuery } from "../../redux/admin/userApi";
import { useLang } from "../../i18n/LanguageProvider";

const LanguageSetting = () => {
  const { data: languages = [] } = useGetIndiaLanguagesQuery();
  const { lang, changeLanguage, t, saving } = useLang();

  const [selected, setSelected] = useState("en");
  useEffect(() => setSelected(lang), [lang]);

  const label = useMemo(
    () => languages.find(l => l.code === selected)?.label || selected,
    [languages, selected]
  );

  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 900 }}>
          {t("LANGUAGE_SETTING", "Language Setting")}
        </Typography>

        <Button
          variant="contained"
          onClick={() => changeLanguage(selected)}
          disabled={saving}
          sx={{
            bgcolor: "#f84f6a",
            "&:hover": { bgcolor: "#e6455f" },
            fontWeight: 900,
            borderRadius: 2
          }}
        >
          {saving ? t("SAVING", "SAVING...") : t("SAVE", "SAVE")}
        </Button>
      </Stack>

      <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, maxWidth: 520 }}>
        <FormControl fullWidth>
          <InputLabel>{t("SELECT_LANGUAGE", "Select Language")}</InputLabel>
          <Select
            value={selected}
            label={t("SELECT_LANGUAGE", "Select Language")}
            onChange={(e) => setSelected(e.target.value)}
          >
            {languages.map((l) => (
              <MenuItem key={l.code} value={l.code}>
                {l.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
          {t("SELECTED", "Selected")}: <b>{label}</b>
        </Typography>
      </Paper>
    </Box>
  );
};

export default LanguageSetting;
